import React from 'react';
import styled from '@emotion/styled';
import type {
  AlignItemsProps,
  HeightProps,
  JustifyContentProps,
  MaxWidthProps,
  WidthProps,
} from 'styled-system';
import { alignItems, height, justifyContent, maxWidth, width } from 'styled-system';

import { objectFit, themeHeight, themeWidth } from '../../theme/system-utilities';
import { Flex } from '../Flex';

interface SuggestionImageProps {
  src: string;
  alt: string;
}

const Container = styled(Flex)<WidthProps & HeightProps & AlignItemsProps & JustifyContentProps>`
  ${themeWidth};
  ${themeHeight};
  ${alignItems};
  ${justifyContent};
`;

const containerStyles = {
  themeWidth: 'sp_32',
  themeHeight: 'sp_32',
  alignItems: 'center',
  justifyContent: 'center',
};

const Image = styled.img<WidthProps & MaxWidthProps & HeightProps>`
  ${width};
  ${maxWidth};
  ${height};
  ${objectFit};
`;

const imageStyles = {
  width: 1,
  maxWidth: '100%',
  height: '100%',
  objectFit: 'contain',
};

const SuggestionImage = ({ src, alt, ...props }: SuggestionImageProps) => (
  <Container {...containerStyles} {...props}>
    <Image src={src} alt={alt} {...imageStyles} />
  </Container>
);

export default SuggestionImage;
